<template>
  <div v-if="$store.state.targets.loaded" class="targets">
    <div class="targets-buttons chart-title d-flex align-items-center">
      <h6 class="targets-title m-0 mr-2">
        {{ $t('dashboard.titles.targets') }}
      </h6>
      <div v-if="targetsVisible">
        <header-radio
          :selected="selectedTarget"
          :options="targets"
          @click="changeSelectedTarget"
          :comparator="(t, selected) => t.targetPrice === selected.targetPrice"
        >
          <template v-slot:default="{ option: target }">
            {{ target.currency }} {{ target.targetPrice }}
          </template>
        </header-radio>
      </div>
    </div>
    <div v-if="targetsVisible" class="target settings-tab Custom_Scrollbar">
      <div class="target-header d-flex align-items-center">
        <h6 class="price">
          {{ selectedTarget.currency }} {{ selectedTarget.targetPrice }}
        </h6>
        <h6
          v-if="profit"
          class="profit"
          :class="[
            profit > 0
              ? 'text-primary'
              : profit < 0
              ? 'text-red'
              : 'text-black',
          ]"
        >
          {{ profit }}%
        </h6>
        |
        <p class="date">
          {{ new Date(selectedTarget.closeDate).toLocaleDateString() }}
        </p>
        |
        <p class="analyst">
          {{ $t('dashboard.targets.analyst') }}:
          {{
            selectedTarget.analyst && selectedTarget.analyst.name[$i18n.locale]
          }}
        </p>
      </div>
      <div class="target-description">
        <div class="text" v-html="description"></div>
      </div>
    </div>
    <buy-key v-else class="targets-buy">
      <p class="text mb-0">
        {{ $t('dashboard.targets.buy.text') }}
        <br />
        <a
          href="https://t.me/RDVPREMIUMbot"
          target="_blank"
          rel="noreferrer"
          class="link"
          >{{ $t('dashboard.targets.buy.link') }}
        </a>
      </p>
    </buy-key>
  </div>
</template>

<script>
import buyKey from '@/components/library/buyKey'
import headerRadioButton from '@/components/library/headerRadioButton'

const md = require('markdown-it')({
  html: true,
  linkify: true,
  typographer: true,
})

export default {
  data() {
    return {
      selectedTarget: this.targets ? this.targets[0] : {},
    }
  },
  methods: {
    changeSelectedTarget(target) {
      this.selectedTarget = target
    },
  },
  computed: {
    profit() {
      if (!this.selectedTarget.openPrice) return false
      return Math.round(
        (this.selectedTarget.targetPrice / this.selectedTarget.openPrice) *
          100 -
          100
      )
    },
    targetsWithoutPrice() {
      return this.$store.state.targets.targets
    },
    targets() {
      const currentPrice = this.$store.state.market.currentPrice
      let targets = this.targetsWithoutPrice
        ? this.targetsWithoutPrice.map((target) => {
            let targetsWithPrice = Object.assign({}, target)
            targetsWithPrice.openPrice = currentPrice
            return targetsWithPrice
          })
        : false
      return targets
    },
    targetsVisible() {
      return this.targets.length
    },
    description() {
      return md.render(
        (this.selectedTarget.description || '')
          .replace(/[\\]/gm, '')
          .replace(/•/gm, '-')
      )
    },
  },
  watch: {
    targetsWithoutPrice() {
      this.selectedTarget = this.targets[0]
    },
    '$store.state.market.currentPrice'(val) {
      if (this.selectedTarget) this.selectedTarget.openPrice = val
    },
  },
  components: {
    'buy-key': buyKey,
    'header-radio': headerRadioButton,
  },
}
</script>

<style lang="scss">
.targets {
  margin-bottom: 22px;
  &-buttons {
    gap: 4px;
  }
  &-title {
    line-height: 20px;
    letter-spacing: 0.5px;
  }
  .target {
    overflow-y: auto;
    margin-top: 16px;
    max-height: 160px;

    &-header {
      gap: 10px;
      color: #c2c2d6;
      line-height: 12px;

      .price,
      .profit {
        margin-bottom: 0;
      }
      .date,
      .analyst {
        font-size: 12px;
        margin: 0;
        color: #8a8a8a;
      }
    }
    &-description {
      .text {
        margin-top: 10px;
        padding-right: 10px;
        font-size: 16px;
        line-height: 24px;
        color: #000000;

        > p,
        > ol,
        > ul {
          margin-bottom: 0.5rem;
        }
      }
    }
  }
  &-buy {
    padding-top: 10px;
    padding-bottom: 12px;
    gap: 8px;
    .text {
      line-height: 24px;
      text-align: center;
      color: $title-color;
      .link {
        color: $primary-color2;
      }
    }
  }
}

@media (max-width: 576px) {
  .targets {
    .target {
      &-header {
        flex-wrap: wrap;
      }
    }
    &-buy {
      padding-top: 8px;
      .text {
        line-height: 18px;
      }
    }
  }
}

#app[data-theme='dark'] {
  .targets {
    .target {
      &-description {
        .text {
          color: inherit;
        }
      }
    }
    &-buy {
      .text {
        color: inherit;
      }
    }
  }
}
</style>
